import React from "react";
import {
  Stack,
  Box,
  Grid,
  TextField,
  Typography,
  IconButton,
  Divider,
} from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

const ProjectsProfile = ({
  data,
  setDataProfile,
  setCurrentDeleteId,
  setModalOpen,
}) => {
  return (
    <Stack>
      {data.projects.length === 0 ? (
        <Typography sx={{ color: "GrayText", textAlign: "center" }}>
          No tienes proyectos
        </Typography>
      ) : null}
      {(data?.projects || []).map((project, index) => (
        <React.Fragment key={project.id}>
          <Box mb={2}>
            <Grid
              container
              spacing={2}
              alignItems="center"
              justifyContent="center"
            >
              <Grid item xs={12} md={2.75} lg={2.75}>
                <TextField
                  label="Nombre"
                  value={project.name}
                  fullWidth
                  onChange={({ target }) => {
                    setDataProfile((adata) => {
                      const newData = {
                        ...adata,
                        projects: [...adata.projects],
                      };
                      newData.projects[index].name = target.value;
                      return newData;
                    });
                  }}
                />
              </Grid>
              <Grid item xs={12} md={2.75} lg={2.75}>
                <TextField
                  label="Telefono"
                  type="text"
                  value={project.phone}
                  fullWidth
                  onChange={({ target }) => {
                    const onlyNums = target.value.replace(/[^0-9]/g, "");
                    setDataProfile((adata) => {
                      const newData = {
                        ...adata,
                        projects: [...adata.projects],
                      };
                      newData.projects[index].phone = onlyNums;
                      return newData;
                    });
                  }}
                />
              </Grid>
              <Grid item xs={12} md={2.75} lg={2.75}>
                <TextField
                  label="Email"
                  value={project.email}
                  fullWidth
                  onChange={({ target }) => {
                    setDataProfile((adata) => {
                      const newData = {
                        ...adata,
                        projects: [...adata.projects],
                      };
                      newData.projects[index].email = target.value;
                      return newData;
                    });
                  }}
                />
              </Grid>
              <Grid item xs={12} md={2.75} lg={2.75}>
                <TextField
                  label="Web"
                  value={project.web}
                  fullWidth
                  onChange={({ target }) => {
                    setDataProfile((adata) => {
                      const newData = {
                        ...adata,
                        projects: [...adata.projects],
                      };
                      newData.projects[index].web = target.value;
                      return newData;
                    });
                  }}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={1}
                sx={{ display: "flex", justifyContent: "center" }}
                lg={1}
              >
                <IconButton
                  onClick={() => {
                    setCurrentDeleteId(project.id);
                    setModalOpen(true);
                  }}
                >
                  <DeleteForeverIcon />
                </IconButton>
              </Grid>
            </Grid>
          </Box>
          <Divider orientation="horizontal" sx={{ mb: 2 }} />
        </React.Fragment>
      ))}
    </Stack>
  );
};

export default ProjectsProfile;
